module.exports = __webpack_public_path__ + "media/images/Blue Mountains Hero-eeada141.webp";